import { PlaceholderGroupTranslationDto } from "../../dto/placeholders/placeholder-group-translations.dto";
import { PlaceholderGroupTranslation } from "../../models/placeholders/placeholder-group.model";

export class PlaceholderGroupTranslationMapper {
  public static toModel(dto: PlaceholderGroupTranslationDto): PlaceholderGroupTranslation {
    return {
      languageId: dto.language_id,
      description: dto.description,
      title: dto.title
    }
  }

  public static toDto(model: PlaceholderGroupTranslation): PlaceholderGroupTranslationDto {
    return {
      language_id: model.languageId,
      description: model.description,
      title: model.title
    }
  }
}